import { __assign, __read } from "tslib";
export function toParams(query) {
    var q = query.replace(/^(\?|#)/, '');
    return q.split('&').reduce(function (values, param) {
        var _a;
        var _b = __read(param.split('='), 2), key = _b[0], value = _b[1];
        return __assign(__assign({}, values), (_a = {}, _a[key] = decodeURIComponent(value), _a));
    }, {});
}
export function toQuery(params, delimiter) {
    if (delimiter === void 0) { delimiter = '&'; }
    var keys = Object.keys(params);
    return keys.reduce(function (str, key, index) {
        var query = "" + str + key + "=" + params[key];
        if (index < keys.length - 1) {
            query += delimiter;
        }
        return query;
    }, '');
}
//# sourceMappingURL=url.js.map